// Utils
import Yup from "../../../utils/yup";

export default Yup.object().shape({
  deliveryType: Yup.string().required("Required"),
  deliveryTime: Yup.string().required("Required"),
});
